module.exports = __webpack_public_path__ + "assets/american-express.00b5162761e130dd258377b012836bb0.svg";